export class Family {
  public Id: number = 0;
  public Name: string = "";
  public Key: string = "";
}
